import { getBlockTitle } from './get-block-title';
import { getBlockIcon } from './get-block-icon';
import { getBlockParentPage } from './get-block-parent-page';
export var getPageBreadcrumbs = function (recordMap, activePageId) {
    var _a, _b, _c, _d;
    var blockMap = recordMap.block;
    var breadcrumbs = [];
    var currentPageId = activePageId;
    do {
        var block = (_a = blockMap[currentPageId]) === null || _a === void 0 ? void 0 : _a.value;
        if (!block) {
            break;
        }
        var title = getBlockTitle(block, recordMap);
        var icon = getBlockIcon(block, recordMap);
        /*
          if the name of the collection view page cannot be found,
          revert to naming it after the collection it views.
        */
        if ((block === null || block === void 0 ? void 0 : block.type) == 'collection_view_page' && !title) {
            var view = (_b = block === null || block === void 0 ? void 0 : block.view_ids) === null || _b === void 0 ? void 0 : _b.map(function (v) { var _a, _b, _c; return (_c = (_b = (_a = recordMap === null || recordMap === void 0 ? void 0 : recordMap.collection_view[v]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.format) === null || _c === void 0 ? void 0 : _c.collection_pointer; }).filter(function (v) { return !!v; }).map(function (v) { var _a; return (_a = recordMap.collection[v.id]) === null || _a === void 0 ? void 0 : _a.value; }).find(function (v) { return !!v; });
            if (view) {
                title = ('View of ' + ((_d = (_c = view.name) === null || _c === void 0 ? void 0 : _c.flat()) === null || _d === void 0 ? void 0 : _d[0]));
                icon = title ? '' : icon;
            }
        }
        if (!(title || icon)) {
            break;
        }
        breadcrumbs.push({
            block: block,
            active: currentPageId === activePageId,
            pageId: currentPageId,
            title: title,
            icon: icon
        });
        var parentBlock = getBlockParentPage(block, recordMap);
        var parentId = parentBlock === null || parentBlock === void 0 ? void 0 : parentBlock.id;
        if (!parentId) {
            break;
        }
        currentPageId = parentId;
        // eslint-disable-next-line no-constant-condition
    } while (true);
    breadcrumbs.reverse();
    return breadcrumbs;
};
//# sourceMappingURL=get-page-breadcrumbs.js.map